import { createContext } from 'react';
var defaultContext = {
  addToast: null,
  removeToast: null
};
export var ToastContext = createContext(defaultContext);